{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "已选择 {conversationCount} 个对话",
    "NONE": "啥都没有",
    "CLEAR_SELECTION": "清除",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "是",
    "CANCEL": "取消",
    "SEARCH_INPUT_PLACEHOLDER": "搜索",
    "ASSIGN_AGENT_TOOLTIP": "分配客服代表",
    "ASSIGN_TEAM_TOOLTIP": "分配一个团队",
    "ASSIGN_SUCCESFUL": "对话分配成功.",
    "ASSIGN_FAILED": "分配对话失败。请再试一次。",
    "RESOLVE_SUCCESFUL": "成功将对话标记为已解决.",
    "RESOLVE_FAILED": "解决对话失败。请再试一次。",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "仅选择了此页面上可见的对话。",
    "UPDATE": {
      "CHANGE_STATUS": "更改状态",
      "SNOOZE_UNTIL": "推迟",
      "UPDATE_SUCCESFUL": "对话状态更新成功。",
      "UPDATE_FAILED": "更新对话失败。请再试一次。"
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "分配标签",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "分配指定的标签",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "已成功分配标签.",
      "ASSIGN_FAILED": "分配标签失败。请再试一次。",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "啥都没有",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "团队分配成功。",
      "ASSIGN_FAILED": "分配团队失败。请再试一次。"
    }
  }
}
